import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleDisciplineDegreeType extends TitleBase {
	private degreeTypeValue: string;
	private disciplineValue: string;

	protected canHandle(): boolean {
		this.degreeTypeValue = this.getFilterValue(ParameterType.DEGREE_TYPE);
		this.disciplineValue = this.getFilterValue(ParameterType.DISCIPLINES);
		const countryContinentFilter = this.filters.filter(
			(_) => _.values.length > 1 && (_.type === ParameterType.COUNTRY || _.type === ParameterType.CONTINENT),
		);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			this.indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE) &&
			countryContinentFilter.length === 0
		);
	}

	protected getPageTitle(): string {
		return `${this.degreeTypeValue} in ${this.disciplineValue}`;
	}

	protected getMetaTitle(): string {
		const degreeTypeValue = this.getFilterMetaTitleValue(ParameterType.DEGREE_TYPE);

		return `${this.totalSearchResults} ${degreeTypeValue} in ${this.disciplineValue} | ${this.portalName}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.degreeTypeValue} in the field of ${this.disciplineValue}`, ' worldwide');
	}
}
